import React, { useRef } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';
import Switch from 'react-switch';
import { useState } from 'react';
import { useEffect } from 'react';
import Http from '@helpers/Http';
import { Api } from '@apis/client';
import Filter from '@helpers/Filter';
import { ISelfClassDisableConfig, ISelfClassDisableTime } from '@apis/types';
import Toast from '@widgets/Toast';
import CommonBtn from '@views/components/CommonBtn';
import ClassDisableSelfMenu from './ClassDisableSelfMenu';
import ConfirmModal from '@views/components/ConfirmModal';
import BrowserHistory from '@helpers/BrowserHistory';
import * as Cache from '../../../../../app/helpers/Cache';
import FridayService from '@services/friday';

const ClassDisableSelfSetting = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [classDisableConfig, setClassDisableConfig] = useState<ISelfClassDisableConfig>({
    isDisableDuringClass: false,
    isDisableDuringHoliday: false,
    allowCallDuringDisableTime: false,
    allowSosDuringDisableTime: true,
    disableTimeConfigs: []
  });
  const [selectedUid, setSelectedUid] = useState('');
  const [showMenu, setShowMenu] = useState(false);

  const textStyle = classDisableConfig?.isDisableDuringClass ? {} : { color: '#B4B9C0' };

  const renderSettingItem = () => {
    const changeClassDisableConfig = async (checked: boolean) => {
      const newConfig = {
        ...classDisableConfig,
        isDisableDuringClass: checked,
      };
      await Http.post(Api.PostClassDisableSelfConfig, {
        sncode: params.current.sncode,
        company: params.current.company,
        ...newConfig,
      }).then(() => {
        setClassDisableConfig(newConfig);
        Toast.show({
          type: 'strip-bottom',
          title: '设置成功',
        });
      });
      FridayService.addEvent('class_disable_class_disable_switch_click', {
        type: checked ? '开' : '关'
      });
    };

    const changeCallConfig = async (checked: boolean) => {
      const newConfig = {
        ...classDisableConfig,
        allowCallDuringDisableTime: checked,
      };
      await Http.post(Api.PostClassDisableSelfConfig, {
        sncode: params.current.sncode,
        company: params.current.company,
        ...newConfig,
      }).then(() => {
        setClassDisableConfig(newConfig);
        Toast.show({
          type: 'strip-bottom',
          title: '设置成功',
        });
      });
      FridayService.addEvent('class_disable_disabled_time_period_to_support_outgoing_call_switch_click', {
        type: checked ? '开' : '关'
      });
    };

    return (
      <div className="flex" styleName="list">
        <div className="flex" styleName="first-container">
          <div className="flex" styleName="first-line">
            <p styleName="title">自定义免打扰</p>
            <Switch
              styleName="border-switch"
              uncheckedIcon={false}
              checkedIcon={false}
              offColor={'#ffffff'}
              onColor={'#256eff'}
              boxShadow={'0 0 1px 1px rgba(0, 0, 0, 0.2)'}
              activeBoxShadow={'0 0 1px 1px rgba(0, 0, 0, 0.08)'}
              width={51}
              height={28}
              onChange={checked => changeClassDisableConfig(checked)}
              checked={classDisableConfig?.isDisableDuringClass || false}
            />
          </div>

          <p>在禁用时，设备静音且限制电话呼出与接听，仍可进行SOS求救</p>
        </div>
        <div className="flex" styleName="second-container">
          <p style={textStyle}>禁用时间段支持电话呼出</p>
          <Switch
            styleName="border-switch"
            uncheckedIcon={false}
            checkedIcon={false}
            offColor={'#ffffff'}
            onColor={'#256eff'}
            boxShadow={'0 0 1px 1px rgba(0, 0, 0, 0.2)'}
            activeBoxShadow={'0 0 1px 1px rgba(0, 0, 0, 0.08)'}
            width={51}
            height={28}
            onChange={checked => changeCallConfig(checked)}
            checked={classDisableConfig?.allowCallDuringDisableTime || false}
            disabled={!(classDisableConfig?.isDisableDuringClass || false)}
          />
        </div>
      </div>
    );
  };

  const loadData = async () => {
    const { data } = await Http.post(Api.GetClassDisableSelfConfig, {
      sncode: params.current.sncode,
      company: params.current.company,
    });
    if (data) {
      setClassDisableConfig(data);
    }
  };

  const renderDisableConfigItems = () => {
    if(classDisableConfig && classDisableConfig.disableTimeConfigs && classDisableConfig.disableTimeConfigs.length > 0) {
      

      const changeConfig = async (timeConfig: ISelfClassDisableTime, checked: boolean, event: React.SyntheticEvent<MouseEvent | KeyboardEvent> | MouseEvent) => {
        event.stopPropagation && event.stopPropagation();
        const index = classDisableConfig.disableTimeConfigs.findIndex((config) => config.uid === timeConfig.uid);
        if(index >= 0) {
          classDisableConfig.disableTimeConfigs[index].isOpen = checked;
          await Http.post(Api.PostClassDisableSelfConfig, {
            sncode: params.current.sncode,
            company: params.current.company,
            ...classDisableConfig
          }).then(() => {
            setClassDisableConfig({...classDisableConfig});
            Toast.show({
              type: 'strip-bottom',
              title: '设置成功',
            });
          })
        }
      }

      const getRepeatText = (days: number[]): string => {
        if (days.length === 7) {
          return '每天';
        }
        if (JSON.stringify([5, 6]) === JSON.stringify(days)) {
          return '周末';
        }
        if (JSON.stringify([0, 1, 2, 3, 4]) === JSON.stringify(days)) {
          return '工作日';
        }
        
        const textMap = {
          0: "周一",
          1: "周二",
          2: "周三",
          3: "周四",
          4: "周五",
          5: "周六",
          6: "周日",
        }
        const daysTextArray = days.map((day) => textMap[day]);
        return daysTextArray.join("、");
      }

      const onTimeConfigClick = (uid: string) => {
        if (classDisableConfig?.isDisableDuringClass || false) {
          setSelectedUid(uid);
          setShowMenu(true);
        }
      }
      
      const items = classDisableConfig.disableTimeConfigs.map((config, index) => {
        return (
          <div key={index} className="flex" styleName='config-container' onClick={() => onTimeConfigClick(config.uid)}>
            <div className='flex' styleName='first-line'>
              <p styleName='title' style={textStyle}>{config.name}</p>
              <Switch
                styleName="border-switch"
                uncheckedIcon={false}
                checkedIcon={false}
                offColor={'#ffffff'}
                onColor={'#256eff'}
                boxShadow={'0 0 1px 1px rgba(0, 0, 0, 0.2)'}
                activeBoxShadow={'0 0 1px 1px rgba(0, 0, 0, 0.08)'}
                width={51}
                height={28}
                onChange={(checked, event) => changeConfig(config, checked, event)}
                checked={config.isOpen}
                disabled={!(classDisableConfig?.isDisableDuringClass || false)}
              />
            </div>
            <p style={textStyle}>{`时间：${config.startTime}-${config.endTime}`}</p>
            <p style={textStyle}>{`重复：${getRepeatText(config.dayIndexList)}`}</p>
          </div>
        );
      });
      return <div className="flex" styleName="list">{items}</div>;
    }
    return null;
  };

  const addDisableConfig = () => {
    FridayService.addEvent('class_disable_add_disable_time_click');
    if (classDisableConfig.disableTimeConfigs?.length >= 10) {
      Toast.show({
        type: 'strip-bottom',
        title: '添加时间已达上限',
      });
    } else {
      Cache.save('disableUid', '');
      Cache.save('selfDisableConfig', classDisableConfig);
      BrowserHistory.push(`${PUBLIC_URL}/deviceClassDisableSelfEdit?sncode=${params.current.sncode}&company=${params.current.company}&action=add`);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const onDelete = () => {
    ConfirmModal.show({
      title: '确认删除？',
      text: '确认后，该禁用时间将被删除',
      confirmBtnText: '删 除',
      confirmTheme: 'warn',
      showCancelBtn: true,
      onConfirm: onDeleteTimeConfig
    });
  }

  const onDeleteTimeConfig = async () => {
    const newConfig = classDisableConfig.disableTimeConfigs.filter((item) => item.uid !== selectedUid);
    const disableConfig = {...classDisableConfig, disableTimeConfigs: newConfig};
    await Http.post(Api.PostClassDisableSelfConfig, {
      sncode: params.current.sncode,
      company: params.current.company,
      ...disableConfig
    }).then(() => {
      setClassDisableConfig(disableConfig);
      Toast.show({
        type: 'strip-bottom',
        title: '删除成功',
      });
    });
  }

  const onEdit = () => {
    Cache.save('disableUid', selectedUid);
    Cache.save('selfDisableConfig', classDisableConfig);
    BrowserHistory.push(`${PUBLIC_URL}/deviceClassDisableSelfEdit?sncode=${params.current.sncode}&company=${params.current.company}&action=edit`)
  }

  return (
    <div styleName="container">
      <NavBar title="自定义免打扰" />
      
      {renderSettingItem()}
      <p styleName="head-text">{`禁用时间 (${classDisableConfig?.disableTimeConfigs?.length || 0}/10)`}</p>
      {renderDisableConfigItems()}
      <CommonBtn
        btnText="添加禁用时间"
        onConfirm={addDisableConfig}
        disabled={!(classDisableConfig?.isDisableDuringClass || false)}
        style={{ marginTop: '.32rem'}}
      />
      {
        showMenu ? (
          <ClassDisableSelfMenu
            uid={selectedUid}
            onClose={ () => setShowMenu(false) }
            onDeleteClick={onDelete}
            onEditClick={onEdit}
          />
        ) : null
      }
      </div>
  );
};

export default ClassDisableSelfSetting;
